// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { parseNonEmptyString as _parseNonEmptyString } from "../../../../io/hyperify/core/types/String";
import PKG from "../../../../../package.json";

function parseNonEmptyString (value : any) : string | undefined {
    return _parseNonEmptyString(value);
}

/**
 * @__PURE__
 */
export const BUILD_USAGE_URL = 'https://github.com/sendanor/project-sendanor.fi';

/**
 * @__PURE__
 */
export const BUILD_VERSION : string  = /* @__PURE__ */parseNonEmptyString(process.env.REACT_APP_VERSION) ?? parseNonEmptyString(PKG?.version) ?? '?';

/**
 * @__PURE__
 */
export const BUILD_LOG_LEVEL : string  = /* @__PURE__ */parseNonEmptyString(process.env.REACT_APP_BUILD_LOG_LEVEL) ?? '';

/**
 * @__PURE__
 */
export const BUILD_NODE_ENV : string  = /* @__PURE__ */parseNonEmptyString(process.env.REACT_APP_BUILD_NODE_ENV) ?? 'development';

/**
 * @__PURE__
 */
export const BUILD_DATE : string  = /* @__PURE__ */parseNonEmptyString(process.env.REACT_APP_BUILD_DATE) ?? '';

/**
 * @__PURE__
 */
export const IS_PRODUCTION  : boolean = BUILD_NODE_ENV === 'production';

/**
 * @__PURE__
 */
export const IS_TEST        : boolean = BUILD_NODE_ENV === 'test';

/**
 * @__PURE__
 */
export const IS_DEVELOPMENT : boolean = !IS_PRODUCTION && !IS_TEST;
